import { $f } from '@/core/services/formatter';

export default {
    install: (app) => {
        app.config.globalProperties.$date = (date, format) => {
            return $f.date(date, format);
        };
    },
};
